import React from 'react';
export default class Clock extends React.Component {
  state = {
    time: 0,
    delay: 1000,
  };

  componentDidMount() {
    this.interval = setInterval(this.tick, this.state.delay);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.delay !== this.state.delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.tick, this.state.delay);
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick = () => {
    var d = new Date("December 3, 2019 20:00:00");
    var d1 = new Date();
    this.setState({
      time: (d1.getTime() - d.getTime())
    });
  }

  handleDelayChange = (e) => {
    this.setState({ delay: Number(e.target.value) });
  }

  toTime(t){
    t /= 1000
    var cd = 24 * 60 * 60,
        ch = 60 * 60,
        cm = 60;
    let d = Math.floor(t / cd)
    let h = Math.floor(t % cd / ch )
    let m = Math.floor(t % cd % ch / cm )
    let s = Math.floor(t % cd % ch % cm )
    if( m === 60 ){h++;m = 0;}
    if( h === 24 ){d++;h = 0;}
    if( s === 60 ){d++;s = 0;}
    return `${d} days, ${h} hours, ${m} minutes, ${s} seconds`;
  }

  render(){
    return <h3>Out of Country {this.toTime(this.state.time)}</h3>
  }

}
